export default __webpack_public_path__ + "static/logoLS-d8c032c7605f27e14852944ae44ea74b.png";